import { render, staticRenderFns } from "./SingleNews.vue?vue&type=template&id=307d8ca8&scoped=true&"
import script from "./SingleNews.vue?vue&type=script&lang=js&"
export * from "./SingleNews.vue?vue&type=script&lang=js&"
import style0 from "./SingleNews.vue?vue&type=style&index=0&id=307d8ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307d8ca8",
  null
  
)

export default component.exports